import useCategories from 'coreHooks/categories/useCategories';
import useCategory from 'coreHooks/categories/useCategory';

export default (categoryResult: ReturnType<typeof useCategory>) => {
	const parentCategoryTree = categoryResult?.category?.parentCategoryTree || [];

	return useCategories(parentCategoryTree);
};
